export const templates = {
  linkedinPost: 'Write a professional and engaging LinkedIn post about [Subject].' +
    ' The post should highlight [Specific Details or Key Points] and emphasize [Key Benefit or Value].' +
    ' Use a conversational tone, include a call-to-action,' +
    ' and make it relatable for professionals in [Industry/Field].' +
    ' Keep it concise (around 3-4 short paragraphs) and ensure it encourages engagement (e.g., likes, comments, or shares).' +
    ' Feel free to add relevant hashtags and emojis to make it visually appealing.',


  igCaption: 'Write a creative and engaging Instagram caption about [Subject].' +
    ' The caption should highlight [Specific Details or Key Points] and convey [Key Emotion or Vibe]. ' +
    'Use a conversational and relatable tone, include relevant emojis,' +
    ' and add a call-to-action to encourage engagement (e.g., likes, comments, or shares).' +
    ' Keep it concise (1-2 sentences) and include 3-5 relevant hashtags for maximum reach.',


  twitterPost: 'Write a concise and engaging Twitter post about [Subject].' +
    ' The post should highlight [Specific Details or Key Points] and convey [Key Emotion or Vibe].' +
    ' Use a conversational tone, include relevant hashtags (2-3), and add a call-to-action to encourage engagement' +
    ' (e.g., likes, retweets, or replies). Keep it within 280 characters and make it punchy and impactful.',
};
